import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import React from 'react';

import { LineGraphT } from './risk-over-time-graph';

type State = Readonly<{
  selectedControls: LineGraphT[];
  allControlData: LineGraphT[];
  name: string;
}>;
const initialState: State = {
  selectedControls: [],
  allControlData: [],
  name: '',
};

export const riskOverTimeSlice = createSlice({
  name: 'risk-over-time',
  initialState,
  reducers: {
    setSelectedControls: (state, { payload }: PayloadAction<LineGraphT[]>) => {
      state.selectedControls = payload ?? [];
    },
    setAllControlData: (state, { payload }: PayloadAction<LineGraphT[]>) => {
      state.allControlData = payload;
    },
    setAssessmentName: (state, { payload }: PayloadAction<string>) => {
      state.name = payload;
    },
  },
});
